import Axios from "axios";

const HTTP = Axios.create({
  crossDomain: true,
  timeout: 10000,
  params: {},
});

HTTP.interceptors.response.use(
  (success) => {
    return success;
  },
  (error) => {
    // Tier feature-gate 403s (backend requireFeature(), identified by the
    // `feature` key in the body) resolve to an empty response instead of
    // rejecting: shared views (e.g. profile) call feature endpoints
    // unconditionally, and their `.catch(console.log)` pattern would
    // otherwise crash on the undefined response. Real errors still reject.
    if (
      error.response?.status === 403 &&
      error.response?.data?.feature
    ) {
      console.info(
        `Feature '${error.response.data.feature}' is disabled for this club - returning empty data.`,
      );
      return Promise.resolve({
        status: 403,
        data: [],
        featureDisabled: error.response.data.feature,
      });
    }
    return Promise.reject(error);
  },
);

HTTP.interceptors.request.use((config) => {
  // config.headers.Authorization = `Bearer ${store.getters["auth/token"]}`;
  return config;
});

export { HTTP };
